import mapConverters from './map_converters';
import axios from 'axios';

function MapDataRequest(url, filter, bounds) {
  this.url = url;
  this.filter = filter;
  this.bounds = bounds;
  this.deferred = $.Deferred();
  this._cancelSource = axios.CancelToken.source();
}


MapDataRequest.prototype = {
  constructor: MapDataRequest,

  cancel: function(message) {
    if (this._cancelSource) {
      this._cancelSource.cancel(message || 'Superseded by a newer cluster request');
    }
  },

  get: function () {

    var self = this;
    var data = {
      '_filter': this.filter
    };

    if(this.bounds){
      data._location = mapConverters.mapBoundsToSparkString( this.bounds );
    }

    axios.get(this.url, {
      withCredentials: true,
      params: data,
      cancelToken: this._cancelSource.token,
    })
      .then(responseData => { self.deferred.resolve(responseData.data)} )
      .catch((error) => { self.deferred.reject(error) });
  },

  getMapList: function() {

    return axios.get(this.url, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
  }

};

export default MapDataRequest;
